import React from "react";
import { browserHistory, Redirect, Route, Router as ReactRouter } from "react-router";

import FormPage from "../containers/FormPage";
import MainPage from "../containers/MainPage";
import Auth from "../containers/Auth";
import Mentor from "../containers/Mentor";

import { FORMS_ROUTE, MENTORS_FORMS_ROUTE, MENTORS_URL, SITE_URL } from "./urls";

export const history = browserHistory;

const error404 = () => (
	<div className="Loader__content">
		<p className="error">ERROR 404: Route not found</p>
		<p style={{ textAlign: "center" }}>
			<a href={SITE_URL} onClick={() => history.push(SITE_URL)}>
				Вернуться
			</a>
		</p>
	</div>
);

const request404 = () => (
	<div className="Loader__content">
		<p className="error">Заявка не найдена. Данная заявка была удалена или принадлежит другому пользователю</p>
		<p style={{ textAlign: "center" }}>
			<a href={SITE_URL} onClick={() => history.push(SITE_URL)}>
				Вернуться
			</a>
		</p>
	</div>
);

const Router = () => (
	<Auth>
		<ReactRouter history={history}>
			<Redirect from="/" to={SITE_URL} />
			<Route path={FORMS_ROUTE} component={FormPage} />
			<Route path={MENTORS_FORMS_ROUTE} component={FormPage} />
			<Route path={SITE_URL} component={MainPage} />
			<Route path={MENTORS_URL} component={Mentor} />
			<Route path={`${SITE_URL}404/request`} component={request404} />
			<Route path={`${SITE_URL}404`} component={error404} />
			<Redirect from="*" to={`${SITE_URL}404`} />
		</ReactRouter>
	</Auth>
);

export default Router;
